module.exports = __webpack_public_path__ + "media/country_flags/mn-f21153ed.png";